import React, { useState, useEffect, Fragment, useRef, createRef } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import { toast } from 'react-toastify';

const ProductInventoryEdit = ({
  data,
  handleValue = null,
  leadId,
  getMaterial,
  getBrand,
  getBrandById,
  getMateriaById,
  handleDataFilter = null,
  handleremoveValue = null,
  prefilledData = null
}) => {
  const objInput = { category_id: '',category_name:'', material_id: '',material_name:'', quantity: '',brand_id: '',brand_name:'', specification:'' };
  const [inputList, setInputList] = useState([]);
  const [inputListData1, setInputListData1] = useState('');
  const [inputListData2, setInputListData2] = useState('');
  const [inputListData3, setInputListData3] = useState('');
  const [inputListData4, setInputListData4] = useState('');
  const [inputListData5, setInputListData5] = useState('');
  const [inputValue, setInputValue] = useState([objInput]);
  const [editInput, setEditInput] = useState([]);
  const [isCurrentRef, setIsCurrentRef] = useState(0);
  const [isError, setIsError] = useState(false);
  const [catVal, setCatVal] = useState('');
  const [catId, setCatId] = useState('');
  const [numberVal, setNumberVal] = useState('');
  const inputRef = useRef([]);
  const [gateData, setGateData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditData, setIsEditData] = useState(false);
  const [materialReq, setMaterialReq] = useState('Yes');
  const [brandId, setBrandId] = useState('');
  const [brandData, setBrandData] = useState([]);
  const [materialNewData, setMaterialNewData] = useState([]);
  const [brands,setBrands] = useState([]);
  


  function editProduct(){
    
  }
  useEffect(() => {
    if (
      prefilledData !== undefined &&
      prefilledData !== null
    ) {
      // console.log(prod_array);
      if (prefilledData != '') {
        // let init = 0;
        let prod_length=prefilledData.length;
        // const list = [...inputValue];
          // console.log(prod_array);
          // console.log('setting values');
          setInputValue(prefilledData);
          // console.log(prod_array);
          setEditInput(prefilledData);
          setInputListData1(prefilledData[prod_length-1]['category_name']);
          setInputListData2(prefilledData[prod_length-1]['quantity']);
          setInputListData3(prefilledData[prod_length-1]['material_name']);
          setInputListData4(prefilledData[prod_length-1]['brand_name']);
          
          if (prod_length > 1) {
            setIsEditData(true);
            setInputList([...inputList, { id: prod_length-1 }]);
          }
        // console.log('out');
        // console.log(inputValue);
      }
    }
  }, [prefilledData]);

  const handleData = () => {
    if (data) {
      setGateData(data);
    }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      handleData();
    }
  }, [data]);

  // useEffect(() => {
  //   if (catId) {
  //     (async () => {
  //       setIsLoading(true);
  //       await getBrandById(catId);
  //       // await getMateriaById(catId);
  //       setIsLoading(false);
  //     })();
  //   }
  // }, [catId]);

  useEffect(() => {
    if (catId) {
      (async () => {
        setIsLoading(true);
      let getBrand = await getBrandById(catId);
      let list = [...brands];
      if(getBrand){
        
        list[isCurrentRef] = getBrand;
        console.log(list)
        setBrandData(list);
        setBrands(list);
        
      }else{
       
        list[isCurrentRef] = getBrand;
        console.log(list)
        setBrandData(list);
        setBrands(list);
      }
        // await getMateriaById(catId);
        setIsLoading(false);
      })();
    }
  }, [catId]);

  useEffect(() => {
    if (brandId) {
      (async () => {
        setIsLoading(true);
        console.log(brandId)
        let categoryIds = [...inputValue];
        console.log(categoryIds);
        if(categoryIds[isCurrentRef].category_id){
          
          let materialsData = await getMateriaById(categoryIds[isCurrentRef].category_id,brandId);
          let listMat = [...materialNewData];
          if(materialsData){
            
            listMat[isCurrentRef] = materialsData;
            console.log(listMat)
            setMaterialNewData(listMat);
            
            
          }else{
          
            listMat[isCurrentRef] = materialsData;
            console.log(listMat)
            setMaterialNewData(listMat);
            
          }
          console.log(materialsData);
        }else{
          toast.error('Category Not selected')
        }
        // let materialsData = await getMateriaById(null,brandId);
        // setMaterialNewData
        
        setIsLoading(false);
      })();
    }
  }, [brandId]);

  // useEffect(() => {
  //   if (brandId) {
  //     (async () => {
  //       setIsLoading(true);
  //       console.log(brandId)
  //       await getMateriaById(null,brandId);
  //       setIsLoading(false);
  //     })();
  //   }
  // }, [brandId]);

  useEffect(() => {
    if (getBrand) {
      console.log(getBrand)
      setBrandData(getBrand);
    }
  }, [getBrand]);

  const addGates = () => {
    if (
      !inputListData1 ||
      !inputListData2 ||
      !inputListData3 ||
      isError
      // !inputListData1.length ||
      // !inputListData2.length ||
      // !inputListData3.length
    ) {
      console.log(inputListData1+' 2 '+inputListData2+' 3 '+inputListData3+' 4 '+isError);
      setIsError(true);
      return false;
    }
    setInputValue([
      ...inputValue,
      { category_id: '',category_name:'', material_id: '',material_name:'', quantity: '',brand_id: '',brand_name:'', specification:'' },
    ]);

    // if (inputListData1?.id) {
    if (inputListData1) {
      if (handleDataFilter) {
        handleDataFilter(inputValue);
      }
    }

    setInputList([...inputList, { id: Math.floor(Math.random() * 100) }]);
    setIsError(false);
    setInputListData1('');
    setInputListData2('');
    setInputListData3('');
    setInputListData4('');
    setInputListData5('');
  };
  const removeGate = (index = null) => {
    console.log(inputValue[index]);
    setInputListData1(inputValue[index]?.category_id);
    setInputListData2(inputValue[index]?.quantity);
    setInputListData3(inputValue[index]?.material_id);
    setInputListData4(inputValue[index]?.brand_id);
    setInputListData5(inputValue[index]?.specification);
    let removeArray = inputValue.splice(index, 1);
    console.log(removeArray);
    inputList.splice(index, 1);
    setInputValue([...inputValue]);
    setInputList([...inputList]);
    if (handleremoveValue) {
      handleremoveValue(removeArray);
    }
  };

  const handleInitalValue = () => {
    setCatVal('');
    setNumberVal('');
    setInputValue([objInput]);
    if (handleremoveValue) {
      handleremoveValue([]);
    }
  };

  const handleFormData = () => {
    if (inputValue) {
      handleValue({
        productData: inputValue,
        materialRequired: materialReq,
      });
    } else {
      handleValue({materialRequired: materialReq});
    }
  };

  useEffect(() => {
    handleFormData();
  }, [inputValue]);

  useEffect(() => {
    handleFormData();
  }, [materialReq]);

  // useEffect(() => {
  //   if (catId) {
  //     (async () => {
  //       setIsLoading(true);
  //       await getMateriaById(catId);
  //       setIsLoading(false);
  //     })();
  //   }
  // }, [catId]);

  useEffect(() => {
    if (getMaterial) {
      setMaterialData(getMaterial);
    }
  }, [getMaterial]);

  const handleInputValue = (val, key, index) => {
    // console.log(index);
    const list = [...inputValue];
    console.log(list);
    console.log(index);
    console.log(key);
    list[index][key] = val;
    setInputValue([...list]);
  };
  return (
    <Fragment>
      <FormSection title={localization.productInventory} isLoading={isLoading}>
       <>
       <DropDownInput
                  label={localization.materialRequired}
                  data={[
                    {"id":"Yes", "name":"Yes"},
                    {"id":"No", "name":"No"}
                  ]}
                  getIdValue={(val) => {
                    setMaterialReq(val.value);
                  }}
                  // errorMsg={localization.isRequired}
                  value={materialReq}
                  // required
                  // isStarRequired={true}
                />
       {inputValue && inputValue.map((value,index) => {
         return (
              <div key={index} className="w-100 row mx-0">
               
              <div className="row mx-0" ref={inputRef.current[index]}>
                <div className='col-md-2'>
                  <DropDownInput
                    label={localization.selectCategory}
                    disabled={value?.freez}
                    data={gateData}
                    getIdValue={(val) => {
                      setInputListData1(val.value);
                      setIsCurrentRef(index);
                      setCatId(val.id);
                      handleInputValue(val.id, 'category_id', index);
                    }}
                    value={value.category_name}
                    // errorMsg={localization.isRequired}
                    // required
                    // isStarRequired={true}
                  />
                </div>
                    {console.log(brands)}
                <div className='col-md-2'>
                  <DropDownInput
                    label={localization.selectBrand}
                    // data={brandData}
                    data={brands[index] && brands[index].length === 0 ? [] : brands[index]}
                    disabled={value?.freez}
                    getIdValue={(val) => {
                      setIsCurrentRef(index);
                      setBrandId(val.id)
                      setInputListData4(val.value);
                      handleInputValue(val.id, 'brand_id', index);
                    }}
                    value={value.brand_name}
                    errorMsg={localization.isRequired}
                    required
                    isStarRequired={true}
                  />
                
              </div>
                <div className='col-md-2'>
                  {/* {value.category_id && ( */}
                  <DropDownInput
                    label={localization.selectMaterial}
                    disabled={value?.freez}
                    // data={materialData.length === 0 ? [] : materialData}
                    data={materialNewData[index] && materialNewData[index].length === 0 ? [] : materialNewData[index]}
                    getIdValue={(val) => {
                      setIsCurrentRef(index);
                      setInputListData3(val.value);
                      handleInputValue(val.id, 'material_id', index);
                    }}
                    errorMsg={localization.isRequired}
                    required
                    isStarRequired={true}
                    value={value.material_name}
                  />
                {/* )} */}
                </div>
                <div className='col-md-2'>
                  <ConstantInput
                    label={localization.quantity}
                    
                    type="number"
                    min={0}
                    handleChange={(val) => {
                      setInputListData2(val);
                      setIsCurrentRef(index);
                      handleInputValue(val, 'quantity', index);
                      setIsError(
                        !Regex.numericNotZero.test(
                          value?.quantity
                        )
                      );
                    }}
                    value={value.quantity}
                    // required
                    // isStarRequired={true}
                  />
                </div>
                <div className='col-md-2'>
                    <ConstantInput
                    label={localization.specification}
                    
                    type="text"
                    value={value?.specification}
                    handleChange={(val) => {
                      // setNumberVal(val);
                      setInputListData5(val);
                      setIsCurrentRef(index);
                      handleInputValue(val, 'specification', index);
                      
                    }}
                    
                  />
                </div>
                <div className='col-md-2'>
                <ButtonWithIcon
                    title="Remove"
                    onClick={() => removeGate(index)}
                  />
                </div>
               
                

                
                <div>
                
                  <br />
                  <br />
                </div>
              </div>
            </div>
         )
       })
       }
      
        {/* {inputList &&
          inputList.map((item, index) => {
            // {console.log('inside');
            //   console.log(index);}
            return (
              <div key={item.id} className="w-100 row mx-0">
                <div className="row mx-0" ref={inputRef.current[index + 1]}>
                  <DropDownInput
                    label={localization.selectCategory}
                    data={gateData}
                    getIdValue={(val) => {
                      setInputListData1(val.value);
                      setIsCurrentRef(index + 1);
                      setCatId(val.id);
                      handleInputValue(val.id, 'category_id', index + 1);
                    }}
                    value={inputValue[index+1].category_name}
                    // errorMsg={localization.isRequired}
                    // required
                    // isStarRequired={true}
                  />
                  {inputValue[index + 1].category_id && (
                    <DropDownInput
                      label={localization.selectMaterial}
                      data={materialData.length === 0 ? [] : materialData}
                      getIdValue={(val) => {
                        setIsCurrentRef(index + 1);
                        setInputListData3(val.value);
                        handleInputValue(val.id, 'material_id', index + 1);
                      }}
                      errorMsg={localization.isRequired}
                      required
                      isStarRequired={true}
                      value={inputValue[index+1].material_name}
                    />
                  )}

                  <ConstantInput
                    label={localization.quantity}
                    
                    type="number"
                    min={0}
                    handleChange={(val) => {
                      setInputListData2(val);
                      setIsCurrentRef(index + 1);
                      handleInputValue(val, 'quantity', index + 1);
                      setIsError(
                        !Regex.numericNotZero.test(
                          inputValue[index + 1]?.quantity
                        )
                      );
                    }}
                    value={inputValue[index+1].quantity}
                    // required
                    // isStarRequired={true}
                  />
                  <div>
                    <ButtonWithIcon
                      title="Remove"
                      onClick={() => removeGate(index)}
                    />
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            );
          })} */}
          </>
        
        
        
        <span>
          {isError ? (
            <label className="error d-block">{localization.enterField}</label>
          ) : null}
        </span>
        <div className="w-100">
          <ButtonWithIcon
            title={localization.addMoreGates}
            onClick={addGates}
          />
        </div>
      </FormSection>
    </Fragment>
  );
};

export default ProductInventoryEdit;
